import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class AchievementModel extends Model {
  static reducer(action, AchievementModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.Achievement.schema:
        action.payload.forEach((payload) => {
          const dbData = AchievementModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          AchievementModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
AchievementModel.modelName = "AchievementModel";

AchievementModel.fields = {
  id: attr(),
};

export default AchievementModel;